import React from 'react';
import { TrackingProperties } from '@/utils/analytics/base-reporter';

export interface ScannerScreenProps {
  children?: React.ReactNode;
}

export enum ScannerType {
  Camera = 'camera_scanner',
  External = 'external_scanner',
}

export enum ScanSound {
  IncrementFirst = 'increment_first',
  IncrementSubsequent = 'increment_subsequent',
  MaxQuantity = 'max_quantity',
  MultipleResults = 'multiple_results',
  NoResults = 'no_results',
  Unavailable = 'unavailable',
}

export enum ScanningEventSource {
  CheckIn = 'check_in',
  CreditRequest = 'credit_request',
  Order = 'order',
  TagBatch = 'tag_batch',
}

export enum ScanningSearchMethod {
  OffDevice = 'off_device',
  OnDevice = 'on_device',
  PreviousScanned = 'previous_scanned',
}

export enum OnDeviceDataset {
  OfflineCatalog = 'offline_catalog',
  OrderGuide = 'order_guide',
}

export enum OffDeviceSearchReason {
  AmbiguousOnDeviceMatch = 'ambiguous_on_device_match',
  NameOnlyOnDeviceMatch = 'name_only_on_device_match',
  NoOnDeviceMatch = 'no_on_device_match',
}

export interface ScanningEventProperties extends TrackingProperties {
  code: string;
  isOfflineCatalogStale?: boolean;
  isOfflineModeActive?: boolean;
  offDeviceSearchReason?: OffDeviceSearchReason;
  offlineCatalogAgeHours?: number | null;
  onDeviceDataset?: OnDeviceDataset;
  rawResults: string[];
  restaurantUUID: string;
  searchMethod: ScanningSearchMethod;
  source: ScanningEventSource;
  supplierUUID: string;
  type: ScannerType;
}

export enum LocalScanLookupPath {
  Local = 'local',
  Network = 'network',
}

export enum LocalScanMatchStatus {
  Ambiguous = 'ambiguous',
  Hit = 'hit',
  Miss = 'miss',
}
